import { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { darkColors } from "../../theme/colors";
import { assetIcons } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import AccountSidebar from "./account-sidebar";
import { StyledTypography } from "./account";
import CustomRadioGroup from "../utils/custom-radio-button";
import { useNavigate } from "react-router-dom";
import routes from "../../constants/routes";
import InlineSvg from "../utils/inline-svg";
// Custom styled components

export default function PrivacyComponent() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const [profileData, setProfileData] = useState({
    displayName: "ExHuma964",
    bio: "60+ Winrate Rune, Highly Rated Rune TOP 15%",
    username: "",
    email: "",
    phone: "",
  });
  const [activityHistory, setActivityHistory] = useState("show");
  const [dataSharing, setDataSharing] = useState("enable");
  const activityOptions = [
    { value: "show", label: "Show" },
    { value: "hide", label: "Hide" },
  ];

  const sharingOptions = [
    { value: "enable", label: "Enable" },
    { value: "disable", label: "Disable" },
  ];
  const navigateToSettings = () => {
    navigate(routes.settings);
  };
  return (
    <Box sx={{ display: "flex", bgcolor: "#171717", height: "100vh" }}>
      {/* Sidebar */}
      {!isMediumScreen && <AccountSidebar />}

      {/* Main content */}
      <Box
        // component="main"
        display={"flex-col"}
        sx={{
          //   flexGrow: 1,
          p: isMediumScreen ? 4 : 10,
          width: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
          },
          pt: isMediumScreen ? 5 : 8,
          mb: 7,
          bgcolor: "#121212",
          color: "#fff",
        }}
      >
        {/* <Container maxWidth=""> */}
        <Stack
          onClick={navigateToSettings}
          direction={"row"}
          sx={{ cursor: "pointer" }}
          alignItems="center"
        >
          {isMediumScreen && (
            <InlineSvg
              sx={{
                cursor: "pointer",
                display: "inline-block",
                width: 20,
                mr: 3,
                pb: 4,
              }}
              url={assetIcons.leftArrow}
            />
          )}
          <Typography
            fontFamily={"MontserratBold"}
            component="span"
            fontSize={
              isMediumScreen ? fontSizes.heading2 : fontSizes.superHeading5
            }
            textAlign={"left"}
            sx={{ mb: isMediumScreen ? 4 : 6 }}
          >
            Privacy
          </Typography>{" "}
        </Stack>

        <Grid container spacing={6}>
          {/* Profile Picture Section */}
          <Grid item xs={12}>
            <Stack
              direction={isMediumScreen ? "column" : "row"}
              spacing={isMediumScreen ? 2 : "24%"}
              justifyContent={isMediumScreen ? "space-between" : "start"}
              alignItems="start"
            >
              <Stack>
                <Typography
                  fontFamily={"MontserratBold"}
                  fontSize={fontSizes.heading3}
                  textAlign={"left"}
                  sx={{ width: isMediumScreen ? "100%" : 180 }}
                >
                  Activity History
                </Typography>
                <StyledTypography sx={{ width: isMediumScreen ? "100%" : 270 }}>
                  Choose whether others can see your History
                </StyledTypography>
              </Stack>
              <CustomRadioGroup
                value={activityHistory}
                onChange={setActivityHistory}
                options={activityOptions}
              />
            </Stack>
          </Grid>
        </Grid>
        <Grid container spacing={isMediumScreen ? 2 : 5} mt={2}>
          {/* Username Section */}
          <Grid item xs={12}>
            <Stack
              direction={isMediumScreen ? "column" : "row"}
              spacing={isMediumScreen ? 2 : "24%"}
              //   justifyContent={"space-between"}
              alignItems={isMediumScreen ? "start" : "center"}
            >
              <Stack>
                <Typography
                  fontFamily={"MontserratBold"}
                  fontSize={fontSizes.heading3}
                  textAlign={"left"}
                  sx={{ width: 160 }}
                >
                  Data Sharing
                </Typography>
                <StyledTypography>
                  Manage data sharing with third parties
                </StyledTypography>
              </Stack>
              <Stack>
                <CustomRadioGroup
                  value={dataSharing}
                  onChange={setDataSharing}
                  options={sharingOptions}
                />
              </Stack>
            </Stack>
          </Grid>
        </Grid>
        {!isMediumScreen && (
          <Box
            mt={6}
            sx={{
              maxWidth: isMediumScreen ? "100%" : "calc(22% + 540px)",
            }}
          >
            <Divider
              sx={{
                background: darkColors.gray,
                width: "100%",
              }}
            />
          </Box>
        )}

        {/* </Container> */}
      </Box>
    </Box>
  );
}
